/**
 * Created by anthony on 7/10/14.
 */
var sliderCud = angular.module('sliderCud', ['classy', 'standardCudFactory']);
sliderCud.factory('SliderCudFactory', function($timeout, StandardCudFactory)
{
    /*var SliderCudFactory = function() {}; */

    var SliderCudFactory = function(model, ctrl)
    {
        this.model = model;
        this.setController(ctrl);
        this.controller.$.items = this.model.get(ctrl.$.familyIndex);
        this.controller.$.itemOpen = false;
        this.controller.$.isValid = false;

        this.controller.$.tab = {};
        this.controller.$.tab.orig = true;

        //this.editItem = [];
        //ctrl.$.origItems = angular.copy(this.model.get());
        //ctrl.$.items = this.model.get();
        //Need to be set in order to compare at them end
        //ctrl.$rootScope.items = ctrl.$.items;
        //ctrl.$rootScope.origItems = ctrl.$.origItems;

    };

    SliderCudFactory.prototype = new StandardCudFactory();
    SliderCudFactory.prototype.parent = StandardCudFactory.prototype;
    SliderCudFactory.prototype.successSave = function(scope, instance, callback)
    {
        var parent = this;
        if(instance.options.config.method == "POST")
         {
             this.controller.$.item.recordID = instance.options.data.id;
             this.controller.$.item.fadeInRight = true;
         }
        if (typeof callback != 'undefined')
            callback();

        this.model.updateCopy();
        $timeout(function()
        {
            parent.setItemOpen(-1);
        }, 1000);
    }
    SliderCudFactory.prototype.successDelete = function(scope, instance)
    {
        this.controller.$.item.fadeInRight = false;
        this.controller.$.item.fadeOutRight = true;
        var openIndex = this.controller.$.index;
        var parent = this;
        $timeout(function()
        {
            parent.setItemOpen(-1);
        }, 1000);
    }
    SliderCudFactory.prototype.add = function()
    {
        this.controller.$.currentSaved = false;
        var index = this.model.new(this.controller.$.familyIndex);
        this.setItemOpen(index);
    }
    SliderCudFactory.prototype.setItemOpen = function(index)
    {
        if(index != -1)
        {
            this.controller.$.itemOpen = true;
            this.controller.$.index = index;
        }
        else
        {
            this.controller.$.itemOpen = false;
        }
    }
    SliderCudFactory.prototype.setEditValue = function(field)
    {
        /** This is FAST Specific */
        if ( this.controller.$.item['x' + field] === null )
            this.controller.$.item['x' + field] = this.controller.$.item[field]
    }
    return SliderCudFactory;
});

sliderCud.service('SliderCudService', function(SliderCudFactory){
    var sliderCud = new SliderCudFactory();
    return sliderCud;
});
